import React from 'react';

import { getAsset } from '../../../../../../../util/assets';
import ProgressiveImage from '../../../../../../../components/global/ProgressiveImage';
import useDismissiblePersistent from '../../../../../../../hooks/useDismissiblePersistent';
import { PHOTO_OBFUSCATION_OVERLAY_TIP } from '../../../../../../../constants/dismissibleKeys';

const ObfuscationInstructionOverlayGuard = () => {
  const { visible, onDismiss } = useDismissiblePersistent(
    PHOTO_OBFUSCATION_OVERLAY_TIP,
  );

  return (
    visible && (
      <div
        className="obfuscation-instruction-overlay-guard"
        onMouseDown={onDismiss}
        role="button"
        tabIndex={0}
      >
        <div className="instruction-space">
          <ProgressiveImage src={getAsset('/icon-hand-press.svg')} />
          <p>
            Press on the photo
            <br />
            to reveal your face!
          </p>
        </div>
      </div>
    )
  );
};

export default ObfuscationInstructionOverlayGuard;
